<mat-dialog-content>
  <div *ngIf="data.html" [innerHTML]="data.html"></div>
  <ngx-json-viewer *ngIf="data.json" [json]="data.json"></ngx-json-viewer>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>
    {{data.actionButtonText}}
  </button>
</mat-dialog-actions>
